export const sortFavoritesByPinnedOrder = (items) => {
  if (!Array.isArray(items)) return [];

  return [...items].sort((a, b) => {
    const aPinned = a?.is_pinned ? 0 : 1;
    const bPinned = b?.is_pinned ? 0 : 1;
    if (aPinned !== bPinned) return aPinned - bPinned;

    const aPinRank = Number.isInteger(a?.pin_rank) ? a.pin_rank : Number.MAX_SAFE_INTEGER;
    const bPinRank = Number.isInteger(b?.pin_rank) ? b.pin_rank : Number.MAX_SAFE_INTEGER;
    if (aPinRank !== bPinRank) return aPinRank - bPinRank;

    const aOrder = Number.isInteger(a?.order_index) ? a.order_index : Number.MAX_SAFE_INTEGER;
    const bOrder = Number.isInteger(b?.order_index) ? b.order_index : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) return aOrder - bOrder;

    const aCreated = a?.created_at || '';
    const bCreated = b?.created_at || '';
    return String(aCreated).localeCompare(String(bCreated));
  });
};
